(function() {
    'use strict';

    angular
        .module('irricrops')
        .controller('vinedoEstacionCtrl',vinedoEstacionCtrl);

    vinedoEstacionCtrl.$inject = ['vinedo', 'global', '$stateParams', 'VinedoRes', 'temporadaFac', 'Config', 'MultiChart'];

    /* @ngInject */
  function vinedoEstacionCtrl(vinedo, global, $stateParams, VinedoRes, temporadaFac, Config, MultiChart) {

    var vm               = this;
    var fecha_inicio     = "2017-01-01";
    var fecha_fin        = "2017-06-01";
    var vinedoId         = $stateParams.id;
    vm.vinedo            = vinedo.data;
    vm.temporadas        = [];
    vm.temporadaSelected = null;
    vm.dateInicio        = moment().subtract(1, "month").toDate();
    vm.dateFin           = moment().toDate();
    vm.loadingGeneral    = true;
    vm.chart             = {
      loadingChart : true,
      mchart       : null,
      chartConfig  : null
    }

    var PERIODO_TEMPORADA = {
      nombre: "temporada"
    };
    var PERIODO_FECHAS = {
      nombre: "Entre Fechas"
    };
    vm.PERIODO_TEMPORADA = PERIODO_TEMPORADA;
    vm.PERIODO_FECHAS = PERIODO_FECHAS;

    vm.periodos = [
      PERIODO_TEMPORADA,
      PERIODO_FECHAS
    ];

    vm.periodoSelected = PERIODO_TEMPORADA;

    vm.getDatosEstacion = function () {
      vm.loadingGeneral = true;
      var dataHttp = {
        fecha_inicio : fecha_inicio,
        fecha_fin    : fecha_fin,
        vinedo_id    : vinedoId
      };
      var p = VinedoRes.getEstacion(dataHttp).$promise;
      p.then(function (res) {
        //success
        //TODO graficar
        vm.graficar(res.data);
        vm.loadingGeneral = false;
      }, function () {
        //fail
        vm.loadingGeneral = false;
      });
      return p;
    };

    vm.graficar = function (data) {
      var mchart = new MultiChart("Gráfico Estación");
      mchart.deletePositioner();

      mchart.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Et0',
        //yAxis     : 13,
        yAxis       : 2,
        lineWidth   : 1,
        suffix      : ' mm',
        type        : 'area',
        data        : data.eto,
        visibleAxis : true
      });

      mchart.agregarSerie({
        color     : Config.colors.temperatura.min,
        name      : 'T min',
        yAxis     : 0,
        lineWidth : 2,
        suffix    : ' °C',
        data      : data.temp_min,
        visible   : false,
        visibleAxis : true
      });

      mchart.agregarSerie({
        color     : Config.colors.temperatura.max,
        name      : 'T max',
        yAxis     : 0,
        lineWidth : 2,
        suffix    : ' °C',
        data      : data.temp_max,
        visible   : false
      });

      mchart.agregarSerie({
        color     : Config.colors.temperatura.med,
        name      : 'T med',
        yAxis     : 0,
        lineWidth : 2,
        suffix    : ' °C',
        data      : data.temp_med,
      });

      mchart.agregarSerie({
        color     : Config.colors.precipitacion.background,
        name      : 'Precipitacion',
        yAxis     : 2,
        type      : 'column',
        lineWidth : 2,
        width     : 5,
        suffix    : ' mm',
        data      : data.precipitacion,
        visibleAxis : true
      });


      vm.chart.mchart = mchart;
      vm.chart.loadingChart = false;
      vm.chart.chartConfig = mchart.getConfig();
      return mchart;
    };

    vm.changeFechas = function(inicio, termino){
      vm.selectPeriodo(PERIODO_FECHAS);
    };

    vm.changeTemporada = function (temporada) {
      //temporadaSelected ya esta modificado por el md-select
      vm.selectPeriodo(PERIODO_TEMPORADA);
    }

    vm.selectPeriodo = function (periodo) {
      if(periodo === PERIODO_TEMPORADA){
        console.log("selectPeriodo temporada");
        fecha_inicio = vm.temporadaSelected.inicio;
        fecha_fin = vm.temporadaSelected.fin;
      }
      if(periodo === PERIODO_FECHAS){
        console.log("selectPeriodo fechas");
        fecha_inicio = moment(vm.dateInicio).format("YYYY-MM-DD");
        fecha_fin    = moment(vm.dateFin).format("YYYY-MM-DD");
      }
      vm.getDatosEstacion();
    };

    vm.init = function () {
      temporadaFac.getTemporadas().then(function (res) {
        vm.temporadas = res.data.data;
        vm.temporadaSelected = temporadaFac.getActiva();
        vm.selectPeriodo(PERIODO_TEMPORADA);
      });
    };

    vm.init();


  }
})();
